import { isGlMapHideOperation } from '@festina/configuration-general-types/configuration'
import { Stack } from '@festina-life/ui/structure'

import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import {
  getGlMapOperationFromDate,
  getGlMapOperationMappingId,
} from '../../uiModels/glMapOperations/helpers'
import type { IndexedGlMapOperationWithMetaData } from '../../uiModels/glMapOperations/types'
import { OperationVersionTooltipEntry } from '../versionedTimeline/OperationVersionTooltipEntry'
import { useIsGlMapVersionActive } from './useIsGlMapVersionActive'

type Props = {
  versions: IndexedGlMapOperationWithMetaData[]
}

/**
 * Describes the GL-map versions sharing a date on the timeline. GL-map versions are
 * selected by changing the view date rather than by navigation, so no link is offered.
 */
export const GlMapVersionsTooltipContent = ({ versions }: Props) => {
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  const isVersionActive = useIsGlMapVersionActive()

  return (
    <Stack className="flex-col">
      {versions.map((version) => (
        <OperationVersionTooltipEntry
          key={version.internalOperation.operationKey}
          identifier={
            getGlMapOperationMappingId(version.internalOperation) ?? '-'
          }
          isActive={isVersionActive(version)}
          isDraft={version.isDraft}
          isInherited={false}
          isHideVersion={isGlMapHideOperation(version.internalOperation)}
          isLockedToChangeset={
            !!untilChangesetKeyValue &&
            version.changesetHistory?.changesetKey === untilChangesetKeyValue
          }
          fromDate={getGlMapOperationFromDate(version.internalOperation)}
          changesetHistory={version.changesetHistory}
          layer={version.layer}
          block={version.block}
        />
      ))}
    </Stack>
  )
}
